export default __webpack_public_path__ + "static/media/back-white-arrow.cf817fdb.svg";